import { t } from 'i18next';
import axios from 'axios';

const apiGetCanadaPostAddress = (postalCode, searchFor) => {
  const reqParamsObj = {
    key: t('CanadaPostAddressCompleteApiKey'),
    countries: { codesList: 'CAN, USA' },
    searchTerm: postalCode,
    LanguagePreference: 'en',
    SearchFor: (searchFor) || 'Everything',
    OrderBy: 'UserLocation',
    $block: true,
    $cache: true,
  };
  return axios.get('https://ws1.postescanada-canadapost.ca/AddressComplete/Interactive/Find/v2.10/json3ex.ws', { params: reqParamsObj });
};

export default apiGetCanadaPostAddress;
